import { useState } from "react";
import { Toast } from "react-bootstrap";
import { useAppDispatch } from "../../redux-stores/hooks/hooks";
import { IToast, removeToast } from "../../redux-stores/reducers/ToastState";

export default function ToastWrapper(props: IToast) {
  const t = props;
  const [show, setShow] = useState(true);
  const dispatch = useAppDispatch();
  return (
    <Toast
      bg={t.bg ?? "Light"}
      onClose={() => {
        setShow(false);
        dispatch(removeToast(t.timestamp));
      }}
      data-testid="toast-main"
      show={show}
      delay={t.duration}
      autohide
    >
      <Toast.Header>
        <strong className="me-auto" data-testid="toast-header">
          {t.header}
        </strong>
      </Toast.Header>
      <Toast.Body
        data-testid="toast-body"
        className={t.bg === "Dark" ? "text-white" : ""}
      >
        {t.body.split("\n").map((b) => (
          <div key={Date.now() * Math.random()}>
            {b}
            <br />
          </div>
        ))}
      </Toast.Body>
    </Toast>
  );
}
